// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H3V23H12.75V11H21V3H18V7H6V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.75 12.9961H23.25V23.2906L19.0029 20.6742L14.75 23.2886V12.9961Z"}}]};

const TaskMarkedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-marked-filled',
    ref,
    icon: element,
  },
));

TaskMarkedFilledIcon.displayName = 'TaskMarkedFilledIcon';

export default TaskMarkedFilledIcon;
